import { z } from "zod";

const translationPath = "page.register.roles.errors.";

const listClassificationSchema = z
  .object({
    id: z.string(),
    name: z.string(),
    code: z.union([z.string(), z.number()]).nullish(),
  })
  .nullish()
  .refine((value) => !!value, {
    message: translationPath + "list_classification",
  });

export const profileListClassificationSchema = z.object({
  listClassification: listClassificationSchema,
});

export type TProfileListClassificationForm = z.infer<
  typeof profileListClassificationSchema
>;
